import { appColors } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { CareerPathWithScore } from '@backrs_ui/grow-ui/src/models/models';

import { View, Text, StyleSheet } from '@react-pdf/renderer';

import { getCareerPathFitColor } from '../util/results.util';

type BestFitCareerPathsPDFProps = Readonly<{
  topThreeCareerPathsWithScore: CareerPathWithScore[];
}>;

export const BestFitCareerPathsPDF = ({
  topThreeCareerPathsWithScore,
}: BestFitCareerPathsPDFProps) => {
  return (
    <View style={styles.container}>
      <View>
        <View style={styles.chip}>
          <Text style={styles.chipTitle}>{appStrings.modules.results.bestFitCareerPath}</Text>
        </View>
      </View>

      <View style={styles.listContainer}>
        {topThreeCareerPathsWithScore.map((path, index) => (
          <View key={index} style={{ width: '33%' }}>
            <View style={styles.lineItemContainer}>
              <View style={styles.blueCircle} />
              <View>
                <Text style={styles.careerPathName}>{path.careerPath.name}</Text>
              </View>
            </View>
            <Text style={styles.careerPathDescription}>{path.careerPath.description}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: appColors.neutral.white,
    border: `1px solid ${appColors.neutral.black}`,
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 16,
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
    boxSizing: 'border-box',
  },
  chipTitle: {
    fontSize: 10,
    color: appColors.color.blue1,
    fontWeight: 'bold',
  },
  listContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: 10,
    paddingTop: 6,
  },
  chip: {
    backgroundColor: appColors.color.blue7,
    padding: 5,
    paddingHorizontal: 10,
    alignSelf: 'flex-start',
    borderRadius: 3,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
  },
  lineItemContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    flexWrap: 'wrap',
  },
  blueCircle: {
    backgroundColor: getCareerPathFitColor('TOP'),
    borderRadius: '50%',
    height: 7,
    width: 7,
  },
  careerPathName: {
    fontSize: 12,
    fontWeight: 700,
  },
  careerPathDescription: {
    fontSize: 9,
    marginLeft: 12,
    marginTop: 4,
  },
});
